/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ aerobic: NonNullable<unknown>, anaerobic: NonNullable<unknown> }} Ui_Te_ValuesInputs */

const en_ui_te_values = /** @type {(inputs: Ui_Te_ValuesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aerobic ${i?.aerobic} · Anaerobic ${i?.anaerobic}`)
};

const de_ui_te_values = /** @type {(inputs: Ui_Te_ValuesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aerob ${i?.aerobic} · Anaerob ${i?.anaerobic}`)
};

/**
* | output |
* | --- |
* | "Aerobic {aerobic} · Anaerobic {anaerobic}" |
*
* @param {Ui_Te_ValuesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_values = /** @type {((inputs: Ui_Te_ValuesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_ValuesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_values(inputs)
	return de_ui_te_values(inputs)
});